module.exports = function _identity(x) { return x; };



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_identity.js
// module id = 351
// module chunks = 0